import { CommonModule, DOCUMENT } from '@angular/common';
import { trigger, transition, animate, style, state } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostListener, inject, model, effect } from '@angular/core';

@Component({
  selector: 'ef-drawer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
  animations: [
    trigger('fadeIn', [
      state('true', style({ opacity: 1 })),
      state('false', style({ opacity: 0 })),
      transition('* => *', [animate('0.3s ease-in-out')]),
    ]),
    trigger('slideRight', [
      state('true', style({ transform: 'translateX(0px)' })),
      state('false', style({ transform: 'translateX(100%)' })),
      transition('* =>  *', [animate('0.5s ease-in-out')]),
    ]),
  ],
  templateUrl: './drawer.component.html',
})
export class EfDrawerComponent {
  public readonly isOpen = model(true);
  public readonly isClosed = model(false);

  private readonly document: Document = inject(DOCUMENT);

  private bodyOverflowState: string | null = null;

  constructor() {
    effect(
      () => {
        if (this.isOpen()) {
          this.isClosed.set(false);
          this.bodyOverflowState = this.document.body.style.overflow;
          this.document.body.style.overflow = 'hidden';
        } else {
          this.document.body.style.overflow = this.bodyOverflowState ?? '';
        }
      },
      { allowSignalWrites: true },
    );
  }

  @HostListener('document:keydown.escape')
  public onEscape(): void {
    this.close();
  }

  public open(): void {
    this.isOpen.set(true);
  }

  public close(): void {
    this.isOpen.set(false);
  }

  public contentAnimationDone(): void {
    if (!this.isOpen()) {
      this.isClosed.set(true);
    }
  }
}
